import React from 'react';
import { ACCOUNTS_MENU as RAW_MENU } from '../../../feature/account/accounts.routes';
import Icon from '../Icon/Icon';
import { Link } from 'react-router-dom';
import { isLoggedInUser } from 'hb-redux-store/util/cookieService';
import InviteAndEarn from '../InviteAndEarn/InviteAndEarn';
import { useInitialData } from 'hb-redux-store/initial.hooks';

const AccountMenu = props => {
  const isUserLoggedIn = isLoggedInUser();
  const { initialData } = useInitialData();
  const { launchInfo } = initialData || {};
  const ACCOUNTS_MENU = RAW_MENU.map(menu => ({
    ...menu,
    // subMenu: menu.subMenu.filter(subMenu => {
    //   if (subMenu.key === 'referral') {
    //     return props.isReferralActive;
    //   }
    //   return true;
    // }),
  }));
  const [menuState, setMenuState] = React.useState(
    ACCOUNTS_MENU.map(menu => ({
      expanded: menu.expanded,
      key: menu.key,
    }))
  );
  const toggleMenu = key => {
    const newMenuState = menuState.map(menu => {
      if (menu.key === key) {
        return { expanded: !menu.expanded, key };
      } else return menu;
    });
    setMenuState(newMenuState);
  };
  const onMenuClick = (subMenu, e) => {
    if (subMenu.key !== 'logout') {
      return true;
    }
    if (subMenu.isPrivate && !isUserLoggedIn) return false;
    e.stopPropagation && e.stopPropagation();
    e.preventDefault && e.preventDefault();
    props.onLogout();
  };

  const getMenuLinks = menu => {
    if (!menu.isPrivate || (menu.isPrivate && isUserLoggedIn)) return menu.url;
    return '/login';
  };

  return ACCOUNTS_MENU.map((menu, index) => (
    <div
      className={`ac-menu std-margin-lr ${
        menuState[index].expanded ? 'expanded' : ''
      } ${index === ACCOUNTS_MENU.length - 1 ? 'last-menu' : ''}`}
      key={menu.key}
    >
      <div
        onClick={() => toggleMenu(menu.key)}
        className="justify-content--space-between"
      >
        <div>
          <div className="ac-menu--title">{menu.title}</div>
          <div className="ac-menu--help-text">{menu.helpText}</div>
        </div>
        <div>
          <Icon
            class={
              menuState[index].expanded
                ? 'icon-common-red-arrow-right arrow-down'
                : 'icon-common-red-arrow-right arrow-up'
            }
            size={10}
          />
        </div>
      </div>
      {menuState[index].expanded &&
        menu.subMenu.map(subMenu => {
          if (subMenu.isExternalLink) {
            return (
              <a
                href={subMenu.url}
                target="_blank"
                className="sub-menu justify-content--space-between"
                key={subMenu.key}
                onClick={e => onMenuClick(subMenu, e)}
              >
                <Icon
                  class={`${subMenu.icon} sub-menu--icon flex-shrink-0`}
                  size={17}
                />
                <div className="sub-menu--title">
                  <span dangerouslySetInnerHTML={{ __html: subMenu.title }} />
                </div>
                {subMenu.key !== 'logout' && (
                  <Icon
                    class="icon-common-red-arrow-right flex-shrink-0"
                    size={10}
                  />
                )}
              </a>
            );
          } else if (!isUserLoggedIn && subMenu.key === 'logout') {
            return false;
          } else {
            return (
              <Link
                to={getMenuLinks(subMenu)}
                className={`sub-menu justify-content--space-between ${
                  subMenu.isPrivate && !isUserLoggedIn ? 'inactive' : ''
                }`}
                key={subMenu.key}
                onClick={e => onMenuClick(subMenu, e)}
              >
                <Icon
                  class={`${subMenu.icon} sub-menu--icon flex-shrink-0`}
                  size={17}
                />
                <div className="sub-menu--title">
                  <span dangerouslySetInnerHTML={{ __html: subMenu.title }} />
                  {subMenu.isNew && (
                    <div className="sub-menu--new icon-new-green-bg">NEW</div>
                  )}
                </div>
                {subMenu.key !== 'logout' && (
                  <Icon
                    class="icon-common-red-arrow-right flex-shrink-0"
                    size={10}
                  />
                )}
              </Link>
            );
          }
        })}
      {index === 0 && (
        <div className="sub-menu--referAndEarn">
          <InviteAndEarn
            iGet={launchInfo?.referrerRewardAmount}
            myFriendsGet={launchInfo?.refereeRewardAmount}
            source="account"
            redirectTo={
              launchInfo?.loggedIn
                ? '/my/vxl-point'
                : '/login?redirectUrl=my/vxl-point'
            }
          />
        </div>
      )}
    </div>
  ));
};

export default AccountMenu;
